import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import { smoothScrollTo } from 'helpers/scrollTo'
import useMobileDetect from 'helpers/mobile-detect'
import DolceLoading from 'components/share/loading'

import styles from './tbanner.module.scss'

export default function Index (props) {
  const [imageUrl, setImageUrl] = useState('/static/images/testimonials/bg-topbaner.png')
  const currentDevice = useMobileDetect()
  const bgImage = 'url(' + imageUrl + ') no-repeat center center / cover #000000'

  const moveToProgram = (e) => {
    e.preventDefault()
    const element = document.getElementById('choose-program')
    if (element) {
      smoothScrollTo('#choose-program')
    }
  }

  useEffect(() => {
    // if (!imageUrl) {
    //   setImageUrl('/static/images/testimonials/bg-topbaner.png')
    // }
    if (currentDevice.isMobile() && currentDevice.width < 768) {
      setImageUrl('/static/images/testimonials/bg-topbaner.png')
    } else {
      setImageUrl('/static/images/testimonials/bg-topbaner.png')
    }
  }, [currentDevice.width])

  return (
    <section className={styles['banner']}>
      {
        !imageUrl &&
        <div className={`${styles['banner__wrapper']} ${styles['banner__wrapper--wait']} wrapper`}>
          <DolceLoading isShow={true} center={true} />
        </div>
      }
      <div className={`${styles['banner__wrapper']} wrapper`} style={{ background: bgImage }}>
        <div className={styles['banner__caption']}>
          <h3 className={styles['banner__title']}>TESTIMONIALS</h3>
          <h4 className={styles['banner__sub-title']}>WHO WILL YOUR STORY INSPIRE?</h4>
          <Button variant='danger' className='bg-red no-border' onClick={moveToProgram}>
            Start your journey TODAY!
          </Button>
        </div>
        <p className={`${styles['banner__text-caption']} ${styles['banner__text-caption-1']}`}>
          "I can’t believe how <br/> fast this program worked"
        </p>
        <p className={`${styles['banner__text-caption']} ${styles['banner__text-caption-2']}`}>"I lost 54 <br/> pounds!"</p>
        <p className={`${styles['banner__text-caption']} ${styles['banner__text-caption-3']} pc`}>"the meals are <br/> incredible! i’m hooked"</p>
        <p className={`${styles['banner__text-caption']} ${styles['banner__text-caption-3']} mobile`}>"the meals are incredible... <br/> i’m hooked"</p>
        <p className={`${styles['banner__text-caption']} ${styles['banner__text-caption-4']} pc`}>"my clothes fit <br/> better than ever!"</p>
        <p className={`${styles['banner__text-caption']} ${styles['banner__text-caption-5']} pc`}>"this program <br/> changed my life"</p>
      </div>
    </section>
  )
}
